import { Button, Input } from "components";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { getAuthUrl } from "utils/api-util";

const AddImidMeters = ({ makeTabActive }) => {
  const [deviceId, setDeviceId] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [version, setVersion] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [protocol, setProtocol] = useState("COMMUNICATION_INTERFACE_MQTT");
  const [meterData, setData] = useState(null);

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [isImidChecked, setIsImidChecked] = useState(false);

  // Get the user
  const user = useSelector((state) => state.auth.userData);

  // Check if just a building is being created
  const isCreateNewBuilding = localStorage.getItem("createNewBuilding");

  const handleCheckboxChange = () => {
    setIsImidChecked(!isImidChecked);
    // Checks the type of user abd check on the box based on the active user
    if (user?.role === "ROLE_SUPER_ADMIN") {
      JSON.stringify(localStorage.setItem("isImidChecked", !isImidChecked));
    } else if (user?.role === "ROLE_ADMIN") {
      JSON.stringify(
        localStorage.setItem("isImidAdminChecked", !isImidChecked)
      );
    }
  };

  // get the checked state
  useEffect(() => {
    // checks which user is logged in to know where to store checked value
    if (user?.role === "ROLE_SUPER_ADMIN") {
      const isChecked = JSON.parse(localStorage.getItem("isImidChecked"));
      if (isChecked) {
        setIsImidChecked(true);
      }
    } else if (user?.role === "ROLE_ADMIN") {
      const isChecked = JSON.parse(localStorage.getItem("isImidAdminChecked"));
      if (isChecked) {
        setIsImidChecked(true);
      }
    }
  }, []);

  // store this data on localstorage
  const imidDevices = {
    deviceId,
    serialNumber,
    version,
    macAddress,
    protocol,
  };

  // make an api call once the user looses focus on the input and update the value stored on loical storage
  const token = window.localStorage.getItem("token");
  const baseUrl = getAuthUrl();
  const url = `${baseUrl}/device/imid/${deviceId}`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const handleBlur = async () => {
    try {
      setIsLoading(true);
      setError("");
      if (isImidChecked) {
        const res = await fetch(url, { headers });
        const data = await res.json();
        console.log(data);
        setData(data);
        setIsLoading(false);
        setError("");
        if (isImidChecked) {
          setDeviceId(data?.deviceId);
          setSerialNumber(data?.serialNumber);
          setVersion(data?.version);
          setMacAddress(data?.macAddress);
          // setProtocol(data?.protocol);
          setProtocol("COMMUNICATION_INTERFACE_MQTT");
          // Another check to know where to store data based on current user
          if (user?.role === "ROLE_SUPER_ADMIN") {
            localStorage.setItem("imidDevices", JSON.stringify(data));
          } else if (user?.role === "ROLE_ADMIN") {
            localStorage.setItem("imidAdminDevices", JSON.stringify(data));
          }
        } else {
          setIsLoading(false);
          return;
        }
      } else {
        setIsLoading("");
        return;
      }
    } catch (error) {
      setError("Invalid device Id");
      setIsLoading(false);
      setSerialNumber("");
      setDeviceId("");
      setVersion("");
      setMacAddress("");
      setProtocol("");
      // localStorage.setItem("imidDevices", JSON.stringify(meterData));
    }
  };

  // check if the user has put in all teh correct values required
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      deviceId === "" ||
      serialNumber === "" ||
      version === "" ||
      macAddress === ""
    ) {
      setError("Please fill all inputs correctly");
      return;
    } else {
      let imidDevicesData = JSON.stringify(imidDevices);
      if (isCreateNewBuilding) {
        makeTabActive(3);
        return;
      }
      if (user?.role === "ROLE_SUPER_ADMIN") {
        if (meterData && isImidChecked) {
          localStorage.setItem("imidDevices", JSON.stringify(meterData));
        } else {
          localStorage.setItem("imidDevices", imidDevicesData);
        }
        makeTabActive(4);
      } else if (user?.role === "ROLE_ADMIN") {
        if (meterData && isImidChecked) {
          localStorage.setItem("imidAdminDevices", JSON.stringify(meterData));
        } else {
          localStorage.setItem("imidAdminDevices", imidDevicesData);
        }
        makeTabActive(3);
      }
    }
  };

  // once the user gets to this screen, he gets all the values stored on local storage
  useEffect(() => {
    if (user?.role === "ROLE_SUPER_ADMIN") {
      const imidDevice = JSON.parse(localStorage.getItem("imidDevices"));
      if (imidDevice) {
        setDeviceId(imidDevice?.deviceId);
        setSerialNumber(imidDevice?.serialNumber);
        setVersion(imidDevice?.version);
        setMacAddress(imidDevice?.macAddress);
        // setProtocol(imidDevice?.protocol);
        setProtocol("COMMUNICATION_INTERFACE_MQTT");
      }
    } else if (user?.role === "ROLE_ADMIN") {
      const imidDevice = JSON.parse(localStorage.getItem("imidAdminDevices"));
      if (imidDevice) {
        setDeviceId(imidDevice?.deviceId);
        setSerialNumber(imidDevice?.serialNumber);
        setVersion(imidDevice?.version);
        setMacAddress(imidDevice?.macAddress);
        // setProtocol(imidDevice?.protocol);
        setProtocol("COMMUNICATION_INTERFACE_MQTT");
      }
    }
  }, []);

  // check if there is already an input stored in localstorage
  useEffect(() => {
    if (user?.role === "ROLE_SUPER_ADMIN") {
      let checkForData = JSON.parse(localStorage.getItem("imidDevices"));
      setData(checkForData);
    } else if (user?.role === "ROLE_ADMIN") {
      let checkForData = JSON.parse(localStorage.getItem("imidAdminDevices"));
      setData(checkForData);
    }
  }, []);

  const goBack = () => {
    if (isCreateNewBuilding) {
      makeTabActive(1);
      return;
    }
    if (user?.role === "ROLE_SUPER_ADMIN") {
      makeTabActive(2);
    } else if (user?.role === "ROLE_ADMIN") {
      makeTabActive(1);
    }
  };

  return (
    <>
      <form>
        <div className="mt-4">
          <div className="">
            <h3 className="building-header">Add IMID Device </h3>
          </div>
          {/* <h3 className="building-header">Add Building.</h3> */}
        </div>
        <div className="flex my-4">
          <input
            onChange={handleCheckboxChange}
            checked={isImidChecked}
            id="check"
            type="checkbox"
            name="checked"
          />
          <label htmlFor="check" className="ml-2">
            Use Existing IMID device.
          </label>
        </div>
        <div className="customer-form-wrapper">
          <div>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="device-id"
              value={deviceId}
              onBlur={handleBlur}
              onChange={(e) => setDeviceId(e.target.value)}
              labelText="Device Id"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-blue-500 peer-focus:dark:text-blue-500"
              name="serialNumber"
              value={serialNumber}
              disabled={isImidChecked ? true : false}
              onChange={(e) => setSerialNumber(e.target.value)}
              labelText="Serial Number"
              required={true}
            ></Input>
          </div>
          <div>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="version"
              value={version}
              onChange={(e) => setVersion(e.target.value)}
              disabled={isImidChecked ? true : false}
              type="string"
              labelText="Version"
            ></Input>
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mt-[25px] px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="Mac-Address"
              value={macAddress}
              onChange={(e) => setMacAddress(e.target.value)}
              disabled={isImidChecked ? true : false}
              labelText="Mac Address"
            ></Input>
          </div>
          <div className=" w-full ">
            <select
              value={protocol}
              onChange={(e) => setProtocol(e.target.value)}
              className="w-full text-sm bg-gray_100 border-[1px] text-[16px] text-gray_600 font-semibold outline-none border-light_blue_800 font-montserrat h-[66px] md:h-[auto] rounded-[10px]"
            >
              <option value="COMMUNICATION_INTERFACE_MQTT">MQTT</option>
              <option value="COMMUNICATION_INTERFACE_MQTT">
                COMMUNICATION_INTERFACE_MQTT
              </option>
            </select>
          </div>
        </div>
        <p className="text-[red] mt-3 text-[12px]">{error}</p>
        {isLoading && (
          <div className="flex items-center mt-3 gap-2">
            <ClipLoader color="#008be0" size={20} />
            <p className="text-[green] text-[12px]"> Please wait</p>
          </div>
        )}
      </form>
      <div className="mt-4">
        <Button
          onClick={goBack}
          type="submit"
          className="border-[1px] mr-4 border-light_blue_800 bg-white cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] rounded-[10px] text-[14px] text-center text-light_blue_800 w-[150px]"
        >
          Back
        </Button>
        <Button
          onClick={handleSubmit}
          className="bg-light_blue_800 cursor-pointer font-extrabold h-[64px] mb-[20px] px-[7px] sm:px-[15px] sm:py-[5px] rounded-[10px] text-[14px] text-center text-white_A700 w-[150px]"
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default AddImidMeters;
